<script>
import { LOGINDMS } from "@/core/services/store/auth.module";
export default {
  name: "dmslogin",
  methods: {
    saveToken() {
      this.$store
        .dispatch(LOGINDMS, this.$route.params.token)
        .then(() => {
          //alert(123);
          const resolved = this.$router.resolve({ name: "admin.dashboard" });
          window.location.href = resolved.href;
        })
        .catch((error) => {
          //alert(456);
          console.log(error);
          this.logError(error);
          this.isDisabled = false;
        });
    },
  },
  mounted() {
    this.saveToken();
  },
};
</script>
